<template>
  <div class="home-page">
    <div class="home-page-inner">
      <b-row>
        <p class="home-text">
          Don't be afraid to find your gifts and
          <span>shine</span>, the world needs your light.
        </p>
      </b-row>
      <b-row align-h="left" class="buttons-wrap">
        <a href="/#/services">
          <button type="button" class="button btn-filled-white">
            Schedule a session <b-icon icon="arrow-right"></b-icon>
          </button>
        </a>
        <a href="/#/order-book">
          <button type="button" class="button btn-filled-white">
            Order Book <b-icon icon="arrow-right"></b-icon>
          </button>
        </a>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Home",
  components: {},

  methods: {
    ...mapActions({
      Login: "Login",
      Logout: "Logout",
    }),
    redirectToAbout() {
      this.$router.push({ path: "/about" });
    },
  },
  mounted() {},
  computed: mapState(["user"]),
};
</script>

<style lang="scss">
@import "../../node_modules/rfs/scss";
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@300;700&display=swap");

.home-page {
  background-image: url("../assets/home-bg.jpg");
  background-size: cover;
  background-position: top right;
  background-repeat: no-repeat;
  padding: 80px;
  min-height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  padding: 20px;
  margin-top: 3.1em;

  @media screen and (min-width: 481px) {
    padding: 40px;
  }

  @media screen and (min-width: 992px) {
    margin-top: 0;
  }
}

.home-page-inner {
  height: 100%;
  padding: 20px 30px;
  width: 100%;
  background-color: rgba(#fff, 0.7);
  align-self: flex-end;

  @media screen and (min-width: 481px) {
    padding: 20px 40px;
  }
  @media screen and (min-width: 768px) {
    width: 50%;
  }
  @media screen and (min-width: 992px) {
    background-color: transparent;
    align-self: center;
  }
}

.home-text {
  font-size: 28px;
  text-align: center;
  font-family: "Montserrat", sans-serif;

  @media screen and (min-width: 481px) {
    font-size: 32px;
  }

  @media screen and (min-width: 576px) {
    font-size: 38px;
    text-align: left;
  }

  @media screen and (min-width: 768px) {
    font-size: 46px;
  }

  @media screen and (min-width: 992px) {
    font-size: 60px;
  }

  span {
    font-weight: 700;
  }
}

.learnmoreBtn {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  max-width: 600px;
}
.learnmore {
  margin-top: 40px;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}

.buttons-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media screen and (min-width: 481px) {
    justify-content: flex-start;
  }

  a {
    margin-right: 15px;
    margin-top: 15px;
  }

  .button {
    font-size: 14px;
    @media screen and (min-width: 768px) {
      font-size: 16px;
    }
  }
}
</style>
